export default "__VITE_ASSET__1ysN3Rbt__"